module.exports = {
	name: 'Octopharma - Alkhalil web app',
	shortName: 'Alkhalil',
	description: 'Alkhalil portal version of the mobile app',
	primaryColor: '#001a33',
	secondaryColor: '#2a8639',
	msTileColor: '#001a33'
}